import { render, staticRenderFns } from "./ActiveList.vue?vue&type=template&id=254ba982"
import script from "./ActiveList.vue?vue&type=script&lang=js"
export * from "./ActiveList.vue?vue&type=script&lang=js"
import style0 from "./ActiveList.vue?vue&type=style&index=0&id=254ba982&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports